<template>
  <v-card class="mx-auto mt-1" outlined width="98%">
    <v-card-text>
      <v-form v-model="valid" lazy-validation @submit.prevent="loadLibrary">
        <v-text-field
          v-model="url"
          label="Library URL"
          placeholder="https://assets.adobe.com/launch-..."
          prepend-icon="mdi-library"
          required
          :rules="urlRules"
          clearable
          clear-icon="mdi-close-thick"
        ></v-text-field>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
function updateUrl(param) {
  window.history.replaceState(
    {},
    document.title,
    window.location.pathname + "?url=" + encodeURIComponent(param)
  );
}

function readFromQueryParam() {
  var search = document.location.search;
  if (search.indexOf("?") === 0) {
    search = search.substring(1);
  }
  var entries = search.split("&");
  var lookup = "url=";
  var entry = entries.find((e) => e.indexOf(lookup) === 0);
  var r = "";
  if (entry !== undefined) {
    r = decodeURIComponent(entry.substring(lookup.length));
    updateUrl(r);
  }
  return r;
}

export default {
  name: "LibrarySelect",
  data: () => ({
    valid: true,
    url: readFromQueryParam(),
    urlRules: [
      (v) => !!v || "url is required",
      //v => (window.location.hostname === Url(v || "").hostname) || 'valid external domain required'
    ],
  }),
  methods: {
    loadLibrary() {
      updateUrl(this.url);
      this.$emit("url-submit", this.url);
    },
  },
  mounted: function () {
    if (this.url !== "") {
      this.$emit("url-submit", this.url);
    }
  },
};
</script>
